export function getExtension(fileName: string) {
  return fileName.slice(fileName.lastIndexOf('.'), fileName.length);
}
